import { Combobox as t } from "@ark-ui/react";
import { combobox as e } from "@huspy/styled-system/recipes";
import { ComboboxContext as r } from "@ark-ui/react/combobox";
import { createStyleContext as n } from "../../utils/createStyleContext.mjs";
const { withProvider: m, withContext: o } = n(e), i = m(t.Root, "root"), c = o(t.ClearTrigger, "clearTrigger"), s = o(
  t.Content,
  "content"
), I = o(
  t.Control,
  "control"
), b = o(
  t.Input,
  "input"
), C = o(t.ItemGroupLabel, "itemGroupLabel"), p = o(
  t.ItemGroup,
  "itemGroup"
), x = o(t.ItemIndicator, "itemIndicator"), a = o(
  t.Item,
  "item"
), l = o(
  t.ItemText,
  "itemText"
), g = o(
  t.Label,
  "label"
), u = o(
  t.Positioner,
  "positioner"
), T = o(
  t.Trigger,
  "trigger"
), P = {
  ClearTrigger: c,
  Content: s,
  Control: I,
  Input: b,
  ItemGroupLabel: C,
  ItemGroup: p,
  ItemIndicator: x,
  Item: a,
  ItemText: l,
  Label: g,
  Positioner: u,
  Root: i,
  Trigger: T,
  Context: r,
  ItemContext: t.ItemContext
};
export {
  P as Combobox
};
